import { render, staticRenderFns } from "./VitalSignsMonitoring.vue?vue&type=template&id=ab10722a&scoped=true&"
import script from "./VitalSignsMonitoring.vue?vue&type=script&lang=js&"
export * from "./VitalSignsMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./VitalSignsMonitoring.vue?vue&type=style&index=0&id=ab10722a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab10722a",
  null
  
)

export default component.exports